module.exports = __webpack_public_path__ + "img/paper_plus.00240a57.svg";